import axios from 'axios'

function saveTableHiddenColumns (tableName, columnKeys) {
  return new Promise((resolve, reject) => {
    axios.post(
      '/api/ui-settings/table-hidden-columns',
      { table_name: tableName, column_keys: columnKeys },
      { headers: { Authorization: 'Bearer' + localStorage.getItem('access_token') }}
    )
  })
}

const prepareKey = key => String(key)

const getters = {
  getTableHiddenColumnKeys: state => (tableName) => state.hiddenColumnKeys[tableName].map(key => parseInt(key) == key ? parseInt(key) : key) ?? []
}

const actions = {
  addHiddenColumnKey ({ commit, state }, { tableName, key }) {
    key = prepareKey(key)
    const keys = state.hiddenColumnKeys[tableName] ?? []
    keys.push(key)
    commit('SET_HIDDEN_COLUMN_KEYS', { tableName, keys })
    return saveTableHiddenColumns(tableName, keys)
  },
  removeHiddenColumnKey ({ commit, dispatch }, { tableName, key }) {
    key = prepareKey(key)
    const keys = state.hiddenColumnKeys[tableName] ?? []
    const index = keys.indexOf(key);
    if (index !== -1) {
      keys.splice(index, 1)
    }
    commit('SET_HIDDEN_COLUMN_KEYS', { tableName, keys })
    return saveTableHiddenColumns(tableName, keys)
  },
  loadTableHiddenColumns ({ commit }, tableName) {
    return new Promise((resolve, reject) => {
      axios.get('/api/ui-settings/table-hidden-columns/' + tableName, {
        headers: {
          Authorization: 'Bearer' + this.getters.getAccessToken
        }
      }).then((res) => {
        commit('SET_HIDDEN_COLUMN_KEYS', { tableName, keys: res.data })
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  }
}

const mutations = {
  SET_HIDDEN_COLUMN_KEYS (state, { tableName, keys }) {
    state.hiddenColumnKeys[tableName] = keys
  }
}

const state = {
  hiddenColumnKeys: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
